import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { FieldValueInterface } from '@vendasta/crm';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';

@Component({
  selector: 'crm-contact-birthday-cell',
  template: `
    @if (birthdayDate(); as date) {
      <div class="birthday-date">
        {{ date | date: "mediumDate":"+0000" }}

      </div>
    } @else {
      <glxy-blank-value></glxy-blank-value>
    }
  `,
  styleUrl: './contact-birthday.component.scss',
  imports: [CommonModule, BlankValueComponent, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactBirthdayCellComponent extends CustomCellComponent {
  fieldValues = signal<(FieldValueInterface | null)[]>([]);
  set value(newValues: (FieldValueInterface | null)[]) {
    this.fieldValues.set(newValues);
  }
  
  birthdayDate = computed(() => {
    const fieldValues = this.fieldValues();
    const birthdayField = fieldValues.find(
      (fieldValue) => fieldValue?.dateValue
    );
    
    if (!birthdayField?.dateValue) {
      return null;
    }
    
    return birthdayField.dateValue;
  });
}
